<template>
  <el-dialog :title="titleName" :visible.sync="dialogFormVisible">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-form-item label="项目名称" :label-width="formLabelWidth" :required="true" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
        <!--<el-input v-model="form.uuid" autocomplete="off" style="display: none;"></el-input>-->
      </el-form-item>
      <el-form-item label="项目编码" :label-width="formLabelWidth" :required="true" prop="code">
        <el-input v-model="form.code" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="功能排序" :label-width="formLabelWidth" :required="true" prop="sort" style="text-align: left">
        <el-input-number v-model="form.sort" controls-position="right" :min="1" :max="100"></el-input-number>
      </el-form-item>
      <el-form-item label="是否启用" :label-width="formLabelWidth" style="text-align: left;" :required="true" prop="isEnable">
         <el-radio v-model="form.isEnable" :label="1">是</el-radio>
         <el-radio v-model="form.isEnable" :label="0">否</el-radio>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
      data() {
        return {
          dialogFormVisible: true,
          url: '',
          titleName: '',
          form: {
            uuid: '',
            name: '',
            code: '',
            sort: '',
            isEnable: ''
          },
          rules: {
            name: [{required: true, message: '请输入项目名称', trigger: 'blur'}],
            code: [{required: true, message: '请输入项目编码', trigger: 'blur'}],
            sort: [{required: true, message: '请输功能排序', trigger: 'blur'}],
            isEnable: [{required: true, message: '请选择是否启用', trigger: 'blur'}]
          },
          formLabelWidth: '120px'
        };
      },
      methods:{
        int(uuid){

          this.dialogFormVisible = true;
          this.form.uuid = '';
          this.form.name = '';
          this.form.code = '';
          this.form.sort = '';
          this.form.isEnable = '';
          this.$refs['ruleForm'].resetFields();

          if(uuid=='add'){
            this.titleName = "项目信息-新增";
            this.url = "/business/system/app/save";
          }else {
            this.titleName = "项目信息-修改";
            this.url = "/business/system/app/update";
            this.$httpTAG({
              url: this.$httpTAG.adornUrl('/business/system/app/view'),
              method: 'post',
              data: this.$httpTAG.adornData({
                'uuid': uuid
              })
            }).then(r => {
              this.form = r.data.data;
            }).finally(r => {})

          }
        },
        addAndUpdate(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$httpTAG({
                url: this.$httpTAG.adornUrl(this.url),
                method: 'post',
                data: this.$httpTAG.adornData({
                  'uuid': this.form.uuid,
                  'name': this.form.name,
                  'code': this.form.code,
                  'sort': this.form.sort,
                  'isEnable': this.form.isEnable
                })
              }).then(res => {
                if (res.data.code == 0) {
                  this.$notify({
                    title: '操作成功！',
                    type: 'success',
                    offset: 600
                  });
                  this.dialogFormVisible = false
                  this.$emit("handleCurrentChange",1);
                } else {
                  this.$message({ // 失败
                    type: 'fail',
                    message: res.data.msg
                  })
                }
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        }
      }
    };
</script>

<style scoped>
</style>
